import { useMemo } from 'react';

import { FilterConfig } from '@components/table';
import { filterSeparator } from '@components/table/filters';

import { useActivityFilter } from './filter-activity';
import { useAssigneeFilter } from './filter-assignee';
import { useDateFilter } from './filter-date';
import { useJobTitleFilter } from './filter-job-title';
import { useLabelsFilter } from './filter-labels';
import { useLanguageFilter } from './filter-language';
import { useNationalRegistryFilter } from './filter-national-registry';
import { usePersonalDetailsFilter } from './filter-personal-details';
import { useRatingFilter } from './filter-rating';
import { useStatusFilter } from './filter-status';

export const useApplicantsTableFilterConfig = () => {
  const personalDetailsFilter = usePersonalDetailsFilter();
  const statusFilter = useStatusFilter();
  const ratingFilter = useRatingFilter();
  const labelsFilter = useLabelsFilter();
  const languageFilter = useLanguageFilter();
  const jobTitleFilter = useJobTitleFilter();
  const assigneeFilter = useAssigneeFilter();
  const dateFilter = useDateFilter();
  const activityFilter = useActivityFilter();
  const nationalRegistryFilter = useNationalRegistryFilter();

  return useMemo<FilterConfig>(() => {
    const filters = [personalDetailsFilter, statusFilter, ratingFilter, labelsFilter];

    if (languageFilter) {
      filters.push(languageFilter);
    }

    filters.push(
      filterSeparator,
      jobTitleFilter,
      assigneeFilter,
      dateFilter,
      filterSeparator,
      activityFilter,
    );

    if (nationalRegistryFilter) {
      filters.push(filterSeparator, nationalRegistryFilter);
    }

    return filters;
  }, [
    personalDetailsFilter,
    statusFilter,
    ratingFilter,
    labelsFilter,
    languageFilter,
    jobTitleFilter,
    assigneeFilter,
    dateFilter,
    activityFilter,
    nationalRegistryFilter,
  ]);
};
